import { LinearProgress } from "@mui/material";
import React from "react";

const Loader: React.FunctionComponent = () => {
	return (
		<LinearProgress
			sx={{
				backgroundColor: "#95d343",
				"& .MuiLinearProgress-bar": {
					backgroundColor: "#95d343",
				},
				position: "absolute",
				top: "64px",
				left: 0,
				right: 0,
				zIndex: 1200,
			}}
		/>
	);
};

export default Loader;
